import React from 'react'
import Table from 'react-bootstrap/Table'
import GenericPagination from '../../shared/GenericPagination'
import Select from 'react-select';
import LeavePlanTitle from '../dashboard/LeavePlanTitle'

class EmployeeLeavePlanTable extends React.Component {
  constructor (props) {
    super (props)

    this.classArray = [{
        element: "name",
        class: "name sortable"
      }, {
        element: "date_range",
        class: "status sortable"
      }]
  }

  renderData (elementType, row, id, index) {
    if (elementType == 'date_range') {
      return <td key={index}>{row[elementType]} </td>
    } else if (elementType == 'name') {
      return (
        <td key={index}><LeavePlanTitle
        title={row['name']}
        leave_plan_id={row['id']}
        key={row['id']}
        /></td>
        )
    } else {
      return <td key={index}>''</td>
    }
  }

  selectedOperation(value, leave_plan_id) {
    this.props.showConfirmation(leave_plan_id, value['value'])
  }

  setOptions(row) {
    let options = [...this.props.options]
    if (row['shared']) {
      return options.map ((option) => {
        let cloneOption = {...option}
        if(cloneOption.value == 'delete') {
          cloneOption['isDisabled'] = true
          cloneOption['label'] = 'Delete (Shared)'
        }
        return cloneOption
      })
    }
    return options
  }

  renderRow (row, index) {
    const options = this.setOptions(row)

    return (
      <tr key={index}>
        { this.classArray.map((element, indx) => this.renderData(element['element'], row, row['id'],indx)) }
        <td>
          <Select
            value={''}
            options={options}
            onChange={(value) => this.selectedOperation(value, row['id'])}
            isSearchable={false}
            placeholder={'Action'}
          />
        </td>
      </tr>
      )
  }

  renderTable () {
    if (this.props.leavePlans.length) {
      return (
        <Table bordered hover >
          <tbody >
            {this.props.leavePlans.map((lp, index) => this.renderRow(lp, index))}
          </tbody>
        </Table>
      )
    } else {
      return (
        <span className="no-data">
          No data to show
        </span>
      )
    }
  }

  render () {
    return (
      (() => this.renderTable())()
    )
  }
}

export default EmployeeLeavePlanTable;
